import { TableAssignmentPriorityLevel } from 'generated/graphql';
import { TableWithCalendarSquares } from 'types/tableBasedInventory';
import { map, size } from 'es-toolkit/compat';
import natsort from 'natsort';

export function getSingleDisplayNameForTables<T extends { name: string }>(tables: T[]): string {
  const sortedTables = sortTablesWithinSectionByName(tables);
  if (size(sortedTables) === 0) {
    return '';
  } else if (size(sortedTables) === 1) {
    return `${sortedTables[0].name}`;
  } else {
    return `${sortedTables[0].name}+`;
  }
}

export function sortTableStringsWithinSection(tableNames: string[]): string[] {
  const tableNameObjs = map(tableNames, (name) => ({ name }));
  return map(sortTablesWithinSectionByName(tableNameObjs), (obj) => obj.name);
}

/**
 * Sorts the tables by name. Previously we handled this manually with a few functions
 * but switching to natsort lib covers more naming pattern cases.
 */
export function sortTablesWithinSectionByName<T extends { name: string }>(tables: T[]): T[] {
  const results = [...tables];
  const compare = natsort();
  return results.sort((x, y) => compare(x.name, y.name));
}

export function sortTablesWithinSectionByPriority(
  tables: TableWithCalendarSquares[]
): TableWithCalendarSquares[] {
  return tables.sort((x, y) => {
    const xPriority = convertPriorityToNumber(
      x.slots[Object.keys(x.slots)[0]]?.calendarSquares[0]?.tablePriorityLevel ?? 'NEUTRAL'
    );
    const yPriority = convertPriorityToNumber(
      y.slots[Object.keys(y.slots)[0]]?.calendarSquares[0]?.tablePriorityLevel ?? 'NEUTRAL'
    );

    return xPriority - yPriority;
  });
}

export const convertPriorityToNumber = (priority: TableAssignmentPriorityLevel) => {
  switch (priority) {
    case 'HIGHEST':
      return 0;
    case 'HIGH':
      return 1;
    case 'NEUTRAL':
    default:
      return 2;
    case 'LOW':
      return 3;
    case 'LOWEST':
      return 4;
  }
};
